import { toast } from 'sonner'
import { setSyncError } from '../../../shared/store/slices/syncSlice'

/**
 * Surface a background cache-refresh failure (REL-01): toast (deduped by id
 * so repeated refreshes don't stack) and record it on the sync slice. Going
 * offline mid-refresh is expected and stays silent — the offline banner
 * already covers that state.
 *
 * The store is imported dynamically to keep services free of a static
 * service → store → slice → service import cycle.
 */
export function reportBackgroundSyncFailure(context: string, error: unknown): void {
  console.warn(`${context}:`, error)
  if (!navigator.onLine) return

  const message = error instanceof Error ? error.message : 'Unknown error'
  toast.error("Couldn't refresh from server", {
    id: 'background-sync-error',
    description: 'Showing locally cached data.',
  })
  void import('../../../shared/store').then(({ store }) => {
    store.dispatch(setSyncError(`${context}: ${message}`))
  })
}
